import { render, staticRenderFns } from "./ed-lesson-creator.vue?vue&type=template&id=03ece022&scoped=true&"
import script from "./ed-lesson-creator.ts?vue&type=script&lang=ts&"
export * from "./ed-lesson-creator.ts?vue&type=script&lang=ts&"
import style0 from "./ed-lesson-creator.scss?vue&type=style&index=0&id=03ece022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ece022",
  null
  
)

export default component.exports